import { createSelector } from 'reselect';
import { tooltipSelector } from './simple-selector';

export const tooltipDataSelector = createSelector(
    tooltipSelector,
    (tooltip) => tooltip.data
);
